import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import API from "../../services/API";
import { TokenService, UsernameService } from "../../services/LocalStorage";
import { RootState } from "../store";
import { useSelector } from "react-redux";

interface User {
  username: string;
  name: string;
  lastName: string;
  companyName: string;
  CompanyID: string;
  CompanyImage: string;
  TowerID: string;
  FloorID: string;
  email: string;
  userImage: string;
  userImageExt: string;
  userImageMime: string;
  isVIP: string;
  disableRule: boolean;
  disableCreateRequest: boolean;
  targetLang: string;
}

const initialState: User = {
  username: "",
  name: "",
  lastName: "",
  companyName: "",
  CompanyImage: "",
  CompanyID: "",
  TowerID: "1",
  FloorID: "1",
  email: "",
  userImage: "",
  userImageExt: "",
  userImageMime: "",
  isVIP: "",
  disableRule: true,
  disableCreateRequest: true,
  targetLang: ""
};

export const UserStorage = createSlice({
  name: "user",
  initialState,
  reducers: {
    setDetails: (
      state: {
        name: string;
        lastName: string;
        username: string;
        companyName: string;
        CompanyImage: string;
        email: string;
        userImage: string;
        userImageExt: string;
        userImageMime: string;
        isVIP: string;
        CompanyID: string;
        TowerID: string;
        FloorID: string;
        disableRule: boolean;
        disableCreateRequest: boolean;
      },
      action: PayloadAction<User>
    ) => {
      state.name = action.payload.name;
      state.lastName = action.payload.lastName;
      state.username = action.payload.username;
      state.companyName = action.payload.companyName;
      state.CompanyImage = action.payload.CompanyImage;
      state.email = action.payload.email;
      state.userImage = action.payload.userImage;
      state.userImageExt = action.payload.userImageExt;
      state.userImageMime = action.payload.userImageMime;
      state.isVIP = action.payload.isVIP;
      state.CompanyID = action.payload.CompanyID;
      state.TowerID = action.payload.CompanyID;
      state.FloorID = action.payload.CompanyID;
      state.disableRule = action.payload.disableRule;
      state.disableCreateRequest = action.payload.disableCreateRequest;
    },
    setLang: (state, action: PayloadAction<string>) => {
      state.targetLang = action.payload;
    },
    cleanStore: () => {
      return { ...initialState };
    },
  },
});

export const getUserDetails = (setLoading?: Function,setDisableRule?: Function) => async (dispatch: any) => {
  try {
    await API()
      .get(`security/GetUserPermisions?token=${TokenService.get()}`)
      .then((response) => {
        const userInfo: any = response.data.Values.UserInfo;

        const userData: User = {
          username: userInfo.Username,
          name: userInfo.Name,
          lastName: userInfo.LastName,
          companyName: userInfo.CompanyName,
          CompanyImage: userInfo.CompanyImage,
          email: userInfo.Email,
          userImage: userInfo.UserImage,
          userImageExt: userInfo.UserImageExt,
          userImageMime: userInfo.UserImageMime,
          isVIP: userInfo.IsVIP,
          CompanyID: userInfo.CompanyID,
          TowerID: userInfo.TowerID,
          FloorID: userInfo.FloorID,
          disableRule: userInfo.disableRule,
          disableCreateRequest: userInfo.disableCreateRequest,
          targetLang: "es"
        };

        UsernameService.set(userData);

        if(setLoading && setDisableRule){
          setDisableRule(userData.disableRule)
          setLoading(false);
        }
        return dispatch(setDetails(userData));
      });
  } catch (e: any) {
    return console.error(e.message);
  }
};

export const { setDetails, setLang , cleanStore } = UserStorage.actions;
export const user = (state: RootState) => state.user;

export default UserStorage.reducer;
